module.exports = __webpack_public_path__ + "static/iba_game_1-74a1ca7a4d90d1c77a1e50de63516558.png";